(function() {
  var maxRetries = 5;
  var retryInterval = 1000; // 1 second
  var retryCount = 0;

  function loadBeelineScript() {
    console.log('Attempting to load Beeline script...');
    var script = document.createElement('script');
    script.src = 'https://brand-api.beelineconnect.com/embed/find_nearby.js?api_key=Rvicw7EkvXGHrvatjAyKSV_vBu-6mbdqfGqluJQqoWI&base_color=000000';
    script.onload = initializeBeeline;
    script.onerror = handleScriptError;
    document.head.appendChild(script);
  }

  function handleScriptError() {
    console.error('Failed to load Beeline script.');
    if (retryCount < maxRetries) {
      retryCount++;
      console.log(`Retrying in ${retryInterval/1000} seconds... (Attempt ${retryCount} of ${maxRetries})`);
      setTimeout(loadBeelineScript, retryInterval);
    } else {
      console.error('Max retries reached. Could not load Beeline script.');
    }
  }

  function initializeBeeline() {
    console.log('Beeline script loaded. Initializing...');
    if (typeof BeelineFindNearby !== 'undefined') {
      console.log('BeelineFindNearby object is available');
      BeelineFindNearby.init();
      setupBeelineButton();
    } else {
      console.error('BeelineFindNearby object is not available');
      handleScriptError();
    }
  }

  function setupBeelineButton() {
    var button = document.querySelector('#beelineButton');
    if (button) {
      console.log('Beeline button found in DOM');
      button.addEventListener('click', handleButtonClick);
    } else {
      console.error('Beeline button not found in DOM');
    }
  }

  function handleButtonClick() {
    console.log('Beeline button clicked');
    var currentVariant = getCurrentVariant();
    var productData = getProductData();
    
    if (currentVariant && currentVariant.barcode && productData) {
      var productTitle = productData.title;
      var variantTitle = currentVariant.title;
      var fullTitle = variantTitle ? productTitle + ' | ' + variantTitle : productTitle;
      
      var beelineUrl = 'https://brand-api.beelineconnect.com/embed/find-nearby?' +
        'base_url=https%3A//brand-api.beelineconnect.com' +
        '&base_color=000000' +
        '&secondary_color=' +
        '&button_text_color=FFFFFF' +
        '&google_api_key=AIzaSyB_MdJ8YY7-mbFzS9Uge27z2CV6XkTFdew' +
        '&title=' + encodeURIComponent('Find ' + fullTitle + ' at dealer') +
        '&disclaimer=Product%20availability%20is%20updated%20every%2024%20hours.%20Please%20call%20your%20nearby%20dealer%20to%20confirm%20inventory%20availability.' +
        '&warning=' +
        '&pid_type=upc' +
        '&api_key=Rvicw7EkvXGHrvatjAyKSV_vBu-6mbdqfGqluJQqoWI' +
        '&default_distance=10000' +
        '&font_family=DINNextLTPro-Regular' +
        '&font_family_url=https://cdn.shopify.com/s/files/1/1928/9661/files/DINNextLTPro-Regular.woff?' +
        '&hide_search_distance=1' +
        '&default_in_stock=1' +
        '&test_ride_button_text=Book%20Test%20Ride' +
        '&test_ride_teaser_text=Earliest%20available' +
        '&include_in_stock_variants=1' +
        '&show_test_rides=0' +
        '&show_placeholder_results=0' +
        '&show_buy_it_now=0' +
        '&variants_in_stock_text=Similar%20Model%28s%29%20In%20Stock' +
        '&available_variants_text=Available%20versions' +
        '&buy_it_now_button_text=Buy%20It%20Now' +
        '&buy_it_now_text=Visit%20retailer%20product%20page%20to%20purchase' +
        '&pid=' + currentVariant.barcode; // Changed from sku to barcode

      console.log('Showing Beeline overlay with URL:', beelineUrl);
      BeelineFindNearby.show(beelineUrl, 'right');
    } else {
      console.error('No barcode available for the current variant');
      alert('Unable to find the product. Please try again or contact support.');
    }
  }

  function getCurrentVariant() {
    var productData = getProductData();
    if (!productData) return null;

    var variantId = getSelectedVariantId(productData);
    if (variantId && productData.variants) {
      return productData.variants.find(v => v.id == variantId);
    }
    return null;
  }

  function getProductData() {
    return window.product 
      || window.ProductJson 
      || window._productJson 
      || window.ProductData 
      || getProductJsonFromDOM()
      || getProductDataFromGlobalVariables()
      || searchForProductDataInPageSource();
  }

  function getProductJsonFromDOM() {
    var scriptTags = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scriptTags.length; i++) {
      try {
        var data = JSON.parse(scriptTags[i].textContent);
        if (data && data.variants) return data;
      } catch (e) {}
    }
    return null;
  }

  function getProductDataFromGlobalVariables() {
    for (var key in window) {
      if (typeof window[key] === 'object' && window[key] !== null) {
        if (window[key].variants && Array.isArray(window[key].variants)) {
          return window[key];
        }
      }
    }
    return null;
  }

  function searchForProductDataInPageSource() {
    var pageSource = document.documentElement.outerHTML;
    var jsonDataRegex = /{[^{}]*"variants":\s*\[[^\]]*\][^{}]*}/g;
    var matches = pageSource.match(jsonDataRegex);
    
    if (matches) {
      for (var i = 0; i < matches.length; i++) {
        try {
          var data = JSON.parse(matches[i]);
          if (data && data.variants) return data;
        } catch (e) {}
      }
    }
    return null;
  }

  function getSelectedVariantId(productData) {
    var variantIdInput = document.querySelector('input[name="id"][data-product-id], input[name="variant-id"]');
    if (variantIdInput) return variantIdInput.value;

    var variantIdSelect = document.querySelector('select[name="id"]');
    if (variantIdSelect) return variantIdSelect.value;

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      return window.ShopifyAnalytics.meta.selectedVariantId;
    }

    if (productData.variants && productData.variants.length > 0) {
      return productData.variants[0].id;
    }

    return null;
  }

  // Wait for DOM to be fully loaded before initializing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadBeelineScript);
  } else {
    loadBeelineScript();
  }
})();